import { ASSET_PATHS } from '../../utils/assetPath';

import './ErrorIcon.css';

interface ErrorIconProps {
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Size of the icon in pixels
   */
  size?: number;
  /**
   * Aria label for accessibility
   */
  ariaLabel?: string;
}

/**
 * ErrorIcon component
 *
 * Displays an error icon using the SVG from the public folder.
 * Used primarily in error states and validation tooltips throughout the application.
 *
 * @example
 * <ErrorIcon />
 * <ErrorIcon size={20} ariaLabel="Error message" />
 */
function ErrorIcon({ className = '', size = 20, ariaLabel = 'Error' }: ErrorIconProps) {
  return (
    <img
      alt={ariaLabel}
      className={`error-icon ${className}`}
      height={size}
      role='img'
      src={ASSET_PATHS.ERROR_ICON}
      width={size}
    />
  );
}

export default ErrorIcon;
